const MOUSE_MODE_ID = 'mouseMode';
let mouseModeEnabled = false;

const addLink = (elementId, href) => {
  let link = document.getElementById(elementId);
  if (!link) {
    link = document.createElement('link');
    link.rel = 'stylesheet';
    link.id = elementId;
    link.href = href;
    document.head.appendChild(link);
  }
};

const removeLink = (elementId) => {
  const link = document.getElementById(elementId);
  if (link) {
    document.head.removeChild(link);
  }
};

export const getMouseMode = () => {
  return mouseModeEnabled;
};

export const setMouseMode = (mouseMode, mouseModeHref) => {
  if (mouseMode) {
    addLink(MOUSE_MODE_ID, mouseModeHref);
    mouseModeEnabled = true;
  }
  else {
    removeLink(MOUSE_MODE_ID);
    mouseModeEnabled = false;
  }
};

export const addFontCss = (fontHref = 'https://files.connectwise.com/UI/Styles/font.css') => {
  addLink('font_css', fontHref);
};


// WEBPACK FOOTER //
// ./src/utils/CwThemeService.js